
import { NavPropertyItems } from '../../navdata/navdata';
import { INavItemsGridOptions, ValidateNotKendoMobile } from '../../navkendo';
import { DialogService, IDialogState } from '@services/dialogservice';
import { fn } from '@common/utils';

/** Show Dialog für Parameters for Muliply Lines */
export function ShowMultiplyDialog(items: NavPropertyItems, selIds: string[], dlg: DialogService) {
    ValidateNotKendoMobile();
    var result = {
        copies: "",
        postingDateFormula: "",
        dueDateFormula: "",
        amount: "",
    };

    var execute = false,
        dlgState: IDialogState;

    return dlg.ShowWindow({
        windowOptions: {
            title: `Aufteilung von ${selIds.length} Belegzeile${selIds.length > 1 ? "n" : ""}`,
            actions: ["Maximize", "Restore", "Close"],
            resizable: true,
            height: 285 + (selIds.length * 25),
            width: "80%"
        },
        controller: ["$scope", function ($scope: ng.IScope) {
            $scope["gridOptions"] = <INavItemsGridOptions>{
                Source: items,
                Filter: selIds
            };
            $scope["info"] = result;
            var close = $scope["Close"] = () => dlgState.window.close();
            $scope["Execute"] = () => {
                items.Anchor.Service.$c.when((!!result.dueDateFormula || !!result.postingDateFormula) || 
                    dlg.ShowConfirm('Es wurde keine Formel für die Aufteilung vorgenommen. Prüfen Sie ggf. noch einmal Ihre Eingaben.\r\n Wollen Sie trotzdem fortfahren?') ).then(ok => {
                    if(ok) {
                        execute = true;
                        close();
                    }
                });
            };
        }],
        template: require("./multiplyLines.html"),
    }).then(w => {
        return (dlgState = w).close.then(() => {
            if (!execute) {
                fn.error.ThrowCancel();
            }

            result.amount = result.amount || "0";
            result.copies = result.copies || "0";
            return result;
        });
    });
}
